// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".apply-for-finance-modal__title{color:#192a44;text-align:center}", "",{"version":3,"sources":["webpack://./resources/assets/js/configurator/components/ApplyForFinanceModal.vue"],"names":[],"mappings":"AAAA,gCAAA,aAAA,CAAA,iBAAA","sourcesContent":[".apply-for-finance-modal__title{text-align:center;color:#192a44}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
